import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cf550df&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf550df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf550df')) {
      api.createRecord('2cf550df', component.options)
    } else {
      api.reload('2cf550df', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cf550df&scoped=true&", function () {
      api.rerender('2cf550df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-base-cost/modules/table-list/index.vue"
export default component.exports